import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import {
    Apps as DashboardIcon,
    FormatListBulletedOutlined as ListOutlinedIcon,
    Tune as GlobalSetupIcon,
} from '@material-ui/icons';
import { SidebarMenu, SidebarMenuItem } from '@commonClient2/components';
import { GLOBAL_SETUP_ROUTE } from '../GlobalSetup';

/**
 * @param {{
 *  title: string;
 *  onIconTitleClick?: Function;
 * }} param0
 */
const AdminSidebar = ({
    title,
    onIconTitleClick,
}) => {
    const { t } = useTranslation('menu', { keyPrefix: 'admin' });
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const [basePath] = pathname.match(/[^/]+/g) || []; // Get first part of path, ex: /admin/dashboard => admin

    const dashboardRoute = `/${basePath}`;
    const globalSetupRoute = `${dashboardRoute}${GLOBAL_SETUP_ROUTE}`;

    return (
        <div className="admin--sidebar">
            <SidebarMenu
                title={title}
                icon={<ListOutlinedIcon />}
                onIconTitleClick={onIconTitleClick}
            >
                <SidebarMenuItem
                    icon={<DashboardIcon />}
                    isActive={dashboardRoute === pathname}
                    onClick={() => navigate(dashboardRoute)}
                    label={t('dashboard')}
                />
                <SidebarMenuItem
                    icon={<GlobalSetupIcon />}
                    isActive={globalSetupRoute === pathname}
                    onClick={() => navigate(globalSetupRoute)}
                    label={t('globalSetup')}
                />
            </SidebarMenu>
        </div>
    );
};

export default AdminSidebar;
